import { getAxios } from './axios.service';

const urlServiceGarde = '/api/PSP/ServiceGarde';
const urlMenu = '/api/PSP/Menu';
const urlSanctions = '/api/PSP/Sanctions';
const urlDelai= '/api/PSP/Delai';
const urlArticle = '/api/PSP/Article/';

export function obtenirServiceGarde() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/PSP')) {
        url.pathname = '/Apps/PSP' + urlServiceGarde;
    }
    else {
        url.pathname = urlServiceGarde;
    }
    return getAxios(url);
}

export function obtenirMenu() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/PSP')) {
        url.pathname = '/Apps/PSP' + urlMenu;
    }
    else {
        url.pathname = urlMenu;
    }
    return getAxios(url);
}

export function obtenirSanctions() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/PSP')) {
        url.pathname = '/Apps/PSP' + urlSanctions;
    }
    else {
        url.pathname = urlSanctions;
    }
    return getAxios(url);
}

export function obtenirDelai() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/PSP')) {
        url.pathname = '/Apps/PSP' + urlDelai;
    }
    else {
        url.pathname = urlDelai;
    }
    return getAxios(url);
}

export function obtenirArticle() {
    const url = new URL(window.location);
    const noArticle = url.pathname.split('/').slice(-1)[0];
    if (url.pathname.startsWith('/Apps/PSP')) {
        url.pathname = '/Apps/PSP' + urlArticle + noArticle;
    }
    else {
        url.pathname = urlArticle + noArticle;
    }
    return getAxios(url);
}
